import { Component, Input } from '@angular/core';
import { CapititelEntryMeta, PersonStammMasterListEntryMeta, PfandrechtMasterDetailEntryMeta } from '../../../../core/gb-api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktCapititelPipe } from '../../../../shared/kompaktdarstellung/capititel/kompakt-capititel.pipe';
import PfandtitelStatusEnum = CapititelEntryMeta.PfandtitelStatusEnum;

@Component({
  selector: 'cap-pfandrecht-capititel',
  templateUrl: './pfandrecht-capititel.component.html',
  styleUrls: ['./pfandrecht-capititel.component.scss'],
  imports: [TranslatePipe, HistoryDirective, KompaktCapititelPipe]
})
export class PfandrechtCapititelComponent {
  @Input()
  recht: PfandrechtMasterDetailEntryMeta;

  constructor(
    private translate: TranslateService,
    private datum: DatumPipe
  ) {
    keysToTranslate(['JaAmDatumDurchAnmelder', 'JA', 'NEIN']);
  }

  getTiteleingang(titel: CapititelEntryMeta): string {
    let text: string;
    const anmelder: string = this.getAnmelder(titel.anmelder);
    const eintragdatum = this.datum.transform(titel.eintragDatum);
    if (titel.pfandtitelStatus === PfandtitelStatusEnum.ERSTELLT || titel.pfandtitelStatus === PfandtitelStatusEnum.EINGETRAGEN) {
      if (anmelder) {
        text = this.translate.instant('JaAmDatumDurchAnmelder', { datum: eintragdatum, anmelder: anmelder });
      } else {
        text = this.translate.instant('JA');
      }
    } else {
      text = this.translate.instant('NEIN');
    }
    return text;
  }

  private getAnmelder(anmelder: Array<PersonStammMasterListEntryMeta>): string {
    return anmelder
      .map((a) => {
        const vorname = a.version.vorname;
        const sitz = a.version.sitz;
        const name = vorname ? [a.version.name, vorname] : [a.version.name];
        if (sitz) {
          return [name.join(' '), sitz].join(', ');
        } else {
          return name.join(' ');
        }
      })
      .join(', ');
  }
}
